module.exports = __webpack_public_path__ + "static/media/IMG_0032-2.cd091489.jpg";